import { StyleSheet } from 'react-native';
import {} from '../constants'
export default StyleSheet.create({
  rootHide: {
   width:0,
   height: 0,
   position: 'absolute',
   top: -900000,
   left: -900000
  },

  root: {
    flex: 1,
   },
   faded: {
    opacity: 0.4
   },
   unFaded: {
    opacity: 1
   },
   loginBGFade:{
     flex: 1,
      backgroundColor: '#000E28',
      opacity: 0.35,
      height: '100%'
    },

   loginBG:{
    flex: 1,

    },

    backgroundPlane:{
      flex: 1,
      backgroundColor: '#000E28',
      height: '100%'
    }






});
